import { StyledDivCaretIcon, StyledIconChevron, StyledTextButton } from './StyledComponents';
import Icon from './Icon';

const FoldersModuleSkeleton = (): JSX.Element => {
  return (
    <StyledTextButton
      disabled={true}
      buttonType="secondary"
      fontType="body"
      icon={<Icon isArchived={false} isSpam={false} isInbox={true} isStar={false} />}
    >
      Inbox
      <StyledDivCaretIcon>
        <StyledIconChevron $isActive={false} fontColor="blue400" size="xs" />
      </StyledDivCaretIcon>
    </StyledTextButton>
  );
};

export default FoldersModuleSkeleton;
